import { useState, useEffect } from 'react'
import { getStats, ApiError } from '../lib/api'
import type { Stats } from '../types/models'

export function useStats() {
  const [stats, setStats] = useState<Stats | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  async function load() {
    setLoading(true)
    setError(null)
    try {
      setStats(await getStats())
    } catch (e) {
      setError(e instanceof ApiError ? e.message : 'Failed to load stats')
    } finally {
      setLoading(false)
    }
  }

  // setState only in async continuations (react-hooks/set-state-in-effect). `loading` starts true.
  useEffect(() => {
    let cancelled = false
    getStats()
      .then((s) => { if (!cancelled) setStats(s) })
      .catch((e) => { if (!cancelled) setError(e instanceof ApiError ? e.message : 'Failed to load stats') })
      .finally(() => { if (!cancelled) setLoading(false) })
    return () => { cancelled = true }
  }, [])

  return { stats, loading, error, refresh: load }
}
